import { useTranslation } from "react-i18next";
import { ConfirmModal } from "mobily-ui-library"
import { useGlobalStore } from "../stores/globalStore";
import { useCheckoutStore } from "../stores/checkoutStore";
import { useShallow } from "zustand/shallow";
import WarningSign from "../assets/WarningSign.svg";

export const ByPassOTPError = () => {
    const { t } = useTranslation();
    const { lang, setBypassOTPError } = useGlobalStore(
        useShallow((state) => ({
            lang: state.lang,
            setBypassOTPError: state.setBypassOTPError,
        }))
    );
    const { goToStep } = useCheckoutStore(useShallow((state) => {
        return {
            goToStep: state.goToStep,
        }
    }))
    const handleReviewInformation = () => {
        goToStep("FTTH-Customer-Details");
    }
    const rtl = lang === 'ar' ? true : false;
    return (
        <div className='coverageErrorWrapper'>
            <ConfirmModal
                title={t("bypass_otp_error_title")}
                subTitle={t("bypass_otp_error_subtitle")}
                buttonName={t("bypass_otp_error_button")}
                showOutlineButton={false}
                showButton={true}
                showIcon={true}
                icon={WarningSign}
                rtl={rtl}
                classNameTitle='errorTitle'
                classNameSubText='errorSubText'
                primaryButtonclassName='errorPrimaryButton'
                onClickClose={() => setBypassOTPError(false)}
                onclickButton={handleReviewInformation}
            />
        </div>
    )
}